module.exports = __webpack_public_path__ + "img/lu.50680de2.svg";